module.exports = __webpack_public_path__ + "media/images/purple-check-32599a229eb088d0baa07ef7bf16ab05.png";